import Head from 'next/head';
import { useState } from 'react';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MindkeyApplicationForm } from '2-feature/Mindkey/ApplicationForm';
import { Breadcrumb } from '2-feature/Navgation/Breadcrumb';
import { Speaker } from '2-feature/Speaker/Speaker';

interface Props {
	vacancy: Mindkey.VacancyDetail;
	vacancyId: string;
	customerId: string;
	content: Content.PageContent;
	isUnsolicitedApplication?: boolean;
}

export const JobPage = ({ vacancy, vacancyId, customerId, content, isUnsolicitedApplication }: Props) => {
	const { applyForPositionButtonText } = (content?.page?.properties as Content.JobListPageProperties)?.texts ?? {};
	const { description, advertisementText } = vacancy ?? {};
	const [showApplicationForm, setShowApplicationForm] = useState(isUnsolicitedApplication ?? false);

	return (
		<>
			<Head>
				<title>{description}</title>
			</Head>
			<MainRegion breadCrumb={<Breadcrumb additionalBreadcrumbItems={[{ title: description }]} />} speaker={<Speaker noBottomSpacing={true} />}>
				<UI_HeaderCard heading={description} />
				<UI_Container width="Small">
					{!showApplicationForm && (
						<>
							<UI_RichText content={advertisementText} />
							<UI_Button
								style="primary"
								onClick={() => {
									setShowApplicationForm(true);
									window.scrollTo({ top: 0, behavior: 'smooth' });
								}}
							>
								{applyForPositionButtonText}
							</UI_Button>
						</>
					)}
					{showApplicationForm && <MindkeyApplicationForm vacancyId={vacancyId} customerId={customerId} />}
				</UI_Container>
				<GoToTopNavigation />
			</MainRegion>
		</>
	);
};
